import { OrderType } from './_generated/graphql';

type SortDirection = 'asc' | 'desc';

export const ORDER_TYPE: Record<SortDirection, OrderType> = {
  asc: OrderType.Asc,
  desc: OrderType.Desc,
};
